export const e2eTokenStorageKey = "e2eToken";
